<template>
	<div>
		<div v-if="obj.templateno==1">
			<svg width="100%" height="100%" viewBox="0 0 300 100">
				<g id="line-1" @mouseenter="hover($event)" @mouseleave="hover($event)">
					<path id="res1" d="M20 20 L50 50 100 50" stroke="#323232" stroke-width="2.0" fill="none" marker-mid="url(#circle)" marker-end="url(#arrow)"
					/>
				</g>
				<g id="line-2" @mouseenter="hover($event)" @mouseleave="hover($event)">
					<path id="res1" d="M20 80 L50 50 100 50" stroke="#323232" stroke-width="2.0" fill="none" marker-mid="url(#circle)" marker-end="url(#arrow)"
					/>
				</g>

				<g id="line-3" @mouseenter="hover($event)" @mouseleave="hover($event)">
					<path id="res1" d="M100 50 L160 50 " stroke="#323232" stroke-width="2.0" fill="none" marker-mid="url(#circle)" marker-end="url(#arrow)"
					/>
				</g>
				<g id="line-4" @mouseenter="hover($event)" @mouseleave="hover($event)">
					<path id="res1" d="M160 50 L220 50 " stroke="#323232" stroke-width="2.0" fill="none" marker-mid="url(#circle)" marker-end="url(#arrow)"
					/>
				</g>
				<g id="line-5" @mouseenter="hover($event)" @mouseleave="hover($event)">
					<path id="res1" d="M220 50 L280 50 " stroke="#323232" stroke-width="2.0" fill="none" marker-mid="url(#circle)" marker-end="url(#arrow)"
					/>
				</g>
				<g id="point-1" @mouseenter="hover($event)" @mouseleave="hover($event)">
					<circle cx="20" cy="20" r="12" stroke="#323232" fill="#fff" />
					<text fill="#000000" font-family="Vijaya" dy=".3em" text-anchor="middle" font-size="13" x="20" y="20">n</text>
				</g>
				<g id="point-2" @mouseenter="hover($event)" @mouseleave="hover($event)">
					<circle cx="20" cy="80" r="12" stroke="#323232" fill="#fff" />
					<text fill="#000000" font-family="Vijaya" dy=".3em" text-anchor="middle" font-size="13" x="20" y="80">w</text>
				</g>
				<g id="point-3" @mouseenter="hover($event)" @mouseleave="hover($event)">
					<circle cx="100" cy="50" r="12" stroke="#323232" fill="#fff" />
					<text fill="#000000" font-family="Vijaya" dy=".3em" text-anchor="middle" font-size="13" x="100" y="50">c</text>
				</g>
				<g id="point-4" @mouseenter="hover($event)" @mouseleave="hover($event)">
					<circle cx="160" cy="50" r="12" stroke="#323232" fill="#fff" />
					<text fill="#000000" font-weight="bold" font-family="Vijaya" dy=".3em" text-anchor="middle" font-size="13" x="160" y="50">l&e</text>
				</g>
				<g id="point-5" @mouseenter="hover($event)" @mouseleave="hover($event)">
					<circle cx="220" cy="50" r="12" stroke="#323232" fill="#fff" />
					<text fill="#000000" font-weight="bold" font-family="Vijaya" dy=".3em" text-anchor="middle" font-size="13" x="220" y="50">0</text>
				</g>
				<g id="point-1" @mouseenter="hover($event)" @mouseleave="hover($event)">
					<circle cx="280" cy="50" r="12" stroke="#323232" fill="#fff" />
					<text fill="#000000" font-weight="bold" font-family="Vijaya" dy=".3em" text-anchor="middle" font-size="13" x="280" y="50">n</text>
				</g>
			</svg>
		</div>
		<div v-if="obj.templateno==3">
			<svg width="100%" height="100%" viewBox="0 0 240 100">
				<g id="line-1" @mouseenter="hover($event)" @mouseleave="hover($event)">
					<path id="res1" d="M20 20 L50 50 100 50" stroke="#323232" stroke-width="2.0" fill="none" marker-mid="url(#circle)" marker-end="url(#arrow)"
					/>
				</g>
				<g id="line-2" @mouseenter="hover($event)" @mouseleave="hover($event)">
					<path id="res1" d="M20 80 L50 50 100 50" stroke="#323232" stroke-width="2.0" fill="none" marker-mid="url(#circle)" marker-end="url(#arrow)"
					/>
				</g>

				<g id="line-3" @mouseenter="hover($event)" @mouseleave="hover($event)">
					<path id="res1" d="M100 50 L160 50 " stroke="#323232" stroke-width="2.0" fill="none" marker-mid="url(#circle)" marker-end="url(#arrow)"
					/>
				</g>
				<g id="line-5" @mouseenter="hover($event)" @mouseleave="hover($event)">
					<path id="res1" d="M160 50 L220 50 " stroke="#323232" stroke-width="2.0" fill="none" marker-mid="url(#circle)" marker-end="url(#arrow)"
					/>
				</g>
				<g id="point-1" @mouseenter="hover($event)" @mouseleave="hover($event)">
					<circle cx="20" cy="20" r="12" stroke="#323232" fill="#fff" />
					<text fill="#000000" font-family="Vijaya" dy=".3em" text-anchor="middle" font-size="13" x="20" y="20">n</text>
				</g>
				<g id="point-2" @mouseenter="hover($event)" @mouseleave="hover($event)">
					<circle cx="20" cy="80" r="12" stroke="#323232" fill="#fff" />
					<text fill="#000000" font-family="Vijaya" dy=".3em" text-anchor="middle" font-size="13" x="20" y="80">w</text>
				</g>
				<g id="point-3" @mouseenter="hover($event)" @mouseleave="hover($event)">
					<circle cx="100" cy="50" r="12" stroke="#323232" fill="#fff" />
					<text fill="#000000" font-family="Vijaya" dy=".3em" text-anchor="middle" font-size="13" x="100" y="50">c</text>
				</g>
				<g id="point-6" @mouseenter="hover($event)" @mouseleave="hover($event)">
					<circle cx="160" cy="50" r="12" stroke="#323232" fill="#fff" />
					<text fill="#000000" font-weight="bold" font-family="Vijaya" dy=".3em" text-anchor="middle" font-size="13" x="160" y="50">l2</text>
				</g>
				<g id="point-1" @mouseenter="hover($event)" @mouseleave="hover($event)">
					<circle cx="220" cy="50" r="12" stroke="#323232" fill="#fff" />
					<text fill="#000000" font-weight="bold" font-family="Vijaya" dy=".3em" text-anchor="middle" font-size="13" x="220" y="50">n</text>
				</g>
			</svg>
		</div>
		<div v-if="obj.templateno==2">
			<svg width="100%" height="100%" viewBox="0 0 360 100">
				<g id="line-1" @mouseenter="hover($event)" @mouseleave="hover($event)">
					<path id="res1" d="M80 20 L110 50 160 50" stroke="#323232" stroke-width="2.0" fill="none" marker-mid="url(#circle)" marker-end="url(#arrow)"
					/>
				</g>
				<g id="line-2" @mouseenter="hover($event)" @mouseleave="hover($event)">
					<path id="res1" d="M80 80 L110 50 160 50" stroke="#323232" stroke-width="2.0" fill="none" marker-mid="url(#circle)" marker-end="url(#arrow)"
					/>
				</g>

				<g id="line-3" @mouseenter="hover($event)" @mouseleave="hover($event)">
					<path id="res1" d="M160 50 L220 50 " stroke="#323232" stroke-width="2.0" fill="none" marker-mid="url(#circle)" marker-end="url(#arrow)"
					/>
				</g>
				<g id="line-4" @mouseenter="hover($event)" @mouseleave="hover($event)">
					<path id="res1" d="M220 50 L280 50 " stroke="#323232" stroke-width="2.0" fill="none" marker-mid="url(#circle)" marker-end="url(#arrow)"
					/>
				</g>
				<g id="line-5" @mouseenter="hover($event)" @mouseleave="hover($event)">
					<path id="res1" d="M280 50 L340 50 " stroke="#323232" stroke-width="2.0" fill="none" marker-mid="url(#circle)" marker-end="url(#arrow)"
					/>
				</g>
				<g id="line-6" @mouseenter="hover($event)" @mouseleave="hover($event)">
					<path id="res1" d="M20 80 L80 80 " stroke="#323232" stroke-width="2.0" fill="none" marker-mid="url(#circle)" marker-end="url(#arrow)"
					/>
				</g>
				<g id="point-6" @mouseenter="hover($event)" @mouseleave="hover($event)">
					<circle cx="20" cy="80" r="12" stroke="#323232" fill="#fff" />
					<text fill="#000000" font-family="Vijaya" dy=".3em" text-anchor="middle" font-size="13" x="20" y="80">w</text>
				</g>
				<g id="point-1" @mouseenter="hover($event)" @mouseleave="hover($event)">
					<circle cx="80" cy="20" r="12" stroke="#323232" fill="#fff" />
					<text fill="#000000" font-family="Vijaya" dy=".3em" text-anchor="middle" font-size="13" x="80" y="20">n</text>
				</g>
				<g id="point-2" @mouseenter="hover($event)" @mouseleave="hover($event)">
					<circle cx="80" cy="80" r="12" stroke="#323232" fill="#fff" />
					<text fill="#000000" font-family="Vijaya" dy=".3em" text-anchor="middle" font-size="13" x="80" y="80">w'</text>
				</g>
				<g id="point-3" @mouseenter="hover($event)" @mouseleave="hover($event)">
					<circle cx="160" cy="50" r="12" stroke="#323232" fill="#fff" />
					<text fill="#000000" font-family="Vijaya" dy=".3em" text-anchor="middle" font-size="13" x="160" y="50">c</text>
				</g>
				<g id="point-4" @mouseenter="hover($event)" @mouseleave="hover($event)">
					<circle cx="220" cy="50" r="12" stroke="#323232" fill="#fff" />
					<text fill="#000000" font-weight="bold" font-family="Vijaya" dy=".3em" text-anchor="middle" font-size="13" x="220" y="50">l</text>
				</g>
				<g id="point-5" @mouseenter="hover($event)" @mouseleave="hover($event)">
					<circle cx="280" cy="50" r="12" stroke="#323232" fill="#fff" />
					<text fill="#000000" font-weight="bold" font-family="Vijaya" dy=".3em" text-anchor="middle" font-size="13" x="280" y="50">0</text>
				</g>
				<g id="point-1" @mouseenter="hover($event)" @mouseleave="hover($event)">
					<circle cx="340" cy="50" r="12" stroke="#323232" fill="#fff" />
					<text fill="#000000" font-weight="bold" font-family="Vijaya" dy=".3em" text-anchor="middle" font-size="13" x="340" y="50">n</text>
				</g>
			</svg>
		</div>
		<div v-if="obj.templateno==4">
			<svg width="100%" height="100%" viewBox="0 0 300 130">
				<g id="line-1" @mouseenter="hover($event)" @mouseleave="hover($event)">
					<path id="res1" d="M20 20 L50 50 100 50" stroke="#323232" stroke-width="2.0" fill="none" marker-mid="url(#circle)" marker-end="url(#arrow)"
					/>
				</g>
				<g id="line-2" @mouseenter="hover($event)" @mouseleave="hover($event)">
					<path id="res1" d="M20 80 L50 50 100 50" stroke="#323232" stroke-width="2.0" fill="none" marker-mid="url(#circle)" marker-end="url(#arrow)"
					/>
				</g>

				<g id="line-3" @mouseenter="hover($event)" @mouseleave="hover($event)">
					<path id="res1" d="M100 50 L160 50 " stroke="#323232" stroke-width="2.0" fill="none" marker-mid="url(#circle)" marker-end="url(#arrow)"
					/>
				</g>
				<g id="line-4" @mouseenter="hover($event)" @mouseleave="hover($event)">
					<path id="res1" d="M160 50 L190 80 220 80 " stroke="#323232" stroke-width="2.0" fill="none" marker-mid="url(#circle)" marker-end="url(#arrow)"
					/>
				</g>
				<g id="line-5" @mouseenter="hover($event)" @mouseleave="hover($event)">
					<path id="res1" d="M160 110 L190 80 220 80 " stroke="#323232" stroke-width="2.0" fill="none" marker-mid="url(#circle)" marker-end="url(#arrow)"
					/>
				</g>
				<g id="line-6" @mouseenter="hover($event)" @mouseleave="hover($event)">
					<path id="res1" d="M220 80 L280 80  " stroke="#323232" stroke-width="2.0" fill="none" marker-mid="url(#circle)" marker-end="url(#arrow)"
					/>
				</g>
				<g id="point-1" @mouseenter="hover($event)" @mouseleave="hover($event)">
					<circle cx="20" cy="20" r="12" stroke="#323232" fill="#fff" />
					<text fill="#000000" font-family="Vijaya" dy=".3em" text-anchor="middle" font-size="13" x="20" y="20">n</text>
				</g>
				<g id="point-2" @mouseenter="hover($event)" @mouseleave="hover($event)">
					<circle cx="20" cy="80" r="12" stroke="#323232" fill="#fff" />
					<text fill="#000000" font-family="Vijaya" dy=".3em" text-anchor="middle" font-size="13" x="20" y="80">w</text>
				</g>
				<g id="point-3" @mouseenter="hover($event)" @mouseleave="hover($event)">
					<circle cx="100" cy="50" r="12" stroke="#323232" fill="#fff" />
					<text fill="#000000" font-family="Vijaya" dy=".3em" text-anchor="middle" font-size="13" x="100" y="50">c</text>
				</g>
				<g id="point-4" @mouseenter="hover($event)" @mouseleave="hover($event)">
					<circle cx="160" cy="50" r="12" stroke="#323232" fill="#fff" />
					<text fill="#000000" font-weight="bold" font-family="Vijaya" dy=".3em" text-anchor="middle" font-size="13" x="160" y="50">l2</text>
				</g>
				<g id="point-1" @mouseenter="hover($event)" @mouseleave="hover($event)">
					<circle cx="160" cy="110" r="12" stroke="#323232" fill="#fff" />
					<text fill="#000000" font-weight="bold" font-family="Vijaya" dy=".3em" text-anchor="middle" font-size="13" x="160" y="110">n</text>
				</g>
				<g id="point-5" @mouseenter="hover($event)" @mouseleave="hover($event)">
					<circle cx="220" cy="80" r="12" stroke="#323232" fill="#fff" />
					<text fill="#000000" font-weight="bold" font-family="Vijaya" dy=".3em" text-anchor="middle" font-size="13" x="220" y="80">0</text>
				</g>
				<g id="point-1" @mouseenter="hover($event)" @mouseleave="hover($event)">
					<circle cx="280" cy="80" r="12" stroke="#323232" fill="#fff" />
					<text fill="#000000" font-weight="bold" font-family="Vijaya" dy=".3em" text-anchor="middle" font-size="13" x="280" y="80">n</text>
				</g>
			</svg>
		</div>
		<div v-if="obj.templateno==5">
			<svg width="100%" height="100%" viewBox="0 0 350 130">
				<g id="line-1" @mouseenter="hover($event)" @mouseleave="hover($event)">
					<path id="res1" d="M20 80 L50 50 100 50" stroke="#323232" stroke-width="2.0" fill="none" marker-mid="url(#circle)" marker-end="url(#arrow)"
					/>
				</g>
				<g id="line-2" @mouseenter="hover($event)" @mouseleave="hover($event)">
					<path id="res1" d="M20 20 L50 50 100 50" stroke="#323232" stroke-width="2.0" fill="none" marker-mid="url(#circle)" marker-end="url(#arrow)"
					/>
				</g>
				<g id="line-3" @mouseenter="hover($event)" @mouseleave="hover($event)">
					<path id="res1" d="M100 50 L160 50 " stroke="#323232" stroke-width="2.0" fill="none" marker-mid="url(#circle)" marker-end="url(#arrow)"
					/>
				</g>
				<g id="line-4" @mouseenter="hover($event)" @mouseleave="hover($event)">
					<path id="res1" d="M160 50 L190 80 220 80 " stroke="#323232" stroke-width="2.0" fill="none" marker-mid="url(#circle)" marker-end="url(#arrow)"
					/>
				</g>
				<g id="line-5" @mouseenter="hover($event)" @mouseleave="hover($event)">
					<path id="res1" d="M160 110 L190 80 220 80 " stroke="#323232" stroke-width="2.0" fill="none" marker-mid="url(#circle)" marker-end="url(#arrow)"
					/>
				</g>
				<g id="line-6" @mouseenter="hover($event)" @mouseleave="hover($event)">
					<path id="res1" d="M220 80 L280 80  " stroke="#323232" stroke-width="2.0" fill="none" marker-mid="url(#circle)" marker-end="url(#arrow)"
					/>
				</g>
				<g id="line-7" @mouseenter="hover($event)" @mouseleave="hover($event)">
					<path id="res1" d="M280 80 L330 80  " stroke="#323232" stroke-width="2.0" fill="none" marker-mid="url(#circle)" marker-end="url(#arrow)"
					/>
				</g>
				<g id="point-1" @mouseenter="hover($event)" @mouseleave="hover($event)">
					<circle cx="20" cy="20" r="12" stroke="#323232" fill="#fff" />
					<text fill="#000000" font-family="Vijaya" dy=".3em" text-anchor="middle" font-size="13" x="20" y="20">n</text>
				</g>
				<g id="point-2" @mouseenter="hover($event)" @mouseleave="hover($event)">
					<circle cx="20" cy="80" r="12" stroke="#323232" fill="#fff" />
					<text fill="#000000" font-family="Vijaya" dy=".3em" text-anchor="middle" font-size="13" x="20" y="80">w</text>
				</g>
				<g id="point-3" @mouseenter="hover($event)" @mouseleave="hover($event)">
					<circle cx="100" cy="50" r="12" stroke="#323232" fill="#fff" />
					<text fill="#000000" font-family="Vijaya" dy=".3em" text-anchor="middle" font-size="13" x="100" y="50">c1</text>
				</g>
				<g id="point-4" @mouseenter="hover($event)" @mouseleave="hover($event)">
					<circle cx="160" cy="50" r="12" stroke="#323232" fill="#fff" />
					<text fill="#000000" font-weight="bold" font-family="Vijaya" dy=".3em" text-anchor="middle" font-size="13" x="160" y="50">l2</text>
				</g>
				<g id="point-1" @mouseenter="hover($event)" @mouseleave="hover($event)">
					<circle cx="160" cy="110" r="12" stroke="#323232" fill="#fff" />
					<text fill="#000000" font-weight="bold" font-family="Vijaya" dy=".3em" text-anchor="middle" font-size="13" x="160" y="110">n</text>
				</g>
				<g id="point-5" @mouseenter="hover($event)" @mouseleave="hover($event)">
					<circle cx="220" cy="80" r="12" stroke="#323232" fill="#fff" />
					<text fill="#000000" font-weight="bold" font-family="Vijaya" dy=".3em" text-anchor="middle" font-size="13" x="220" y="80">c2</text>
				</g>
				<g id="point-6" @mouseenter="hover($event)" @mouseleave="hover($event)">
					<circle cx="280" cy="80" r="12" stroke="#323232" fill="#fff" />
					<text fill="#000000" font-weight="bold" font-family="Vijaya" dy=".3em" text-anchor="middle" font-size="13" x="280" y="80">o</text>
				</g>
				<g id="point-1" @mouseenter="hover($event)" @mouseleave="hover($event)">
					<circle cx="330" cy="80" r="12" stroke="#323232" fill="#fff" />
					<text fill="#000000" font-weight="bold" font-family="Vijaya" dy=".3em" text-anchor="middle" font-size="13" x="330" y="80">n</text>
				</g>
			</svg>
		</div>
		<div v-if="obj.templateno==6">
			<svg width="100%" height="100%" viewBox="0 0 360 130">
				<g id="line-8" @mouseenter="hover($event)" @mouseleave="hover($event)">
					<path id="res1" d="M20 80 L70 80  " stroke="#323232" stroke-width="2.0" fill="none" marker-mid="url(#circle)" marker-end="url(#arrow)"
					/>
				</g>
				<g id="line-1" @mouseenter="hover($event)" @mouseleave="hover($event)">
					<path id="res1" d="M70 80 L90 50 120 50" stroke="#323232" stroke-width="2.0" fill="none" marker-mid="url(#circle)" marker-end="url(#arrow)"
					/>
				</g>
				<g id="line-2" @mouseenter="hover($event)" @mouseleave="hover($event)">
					<path id="res1" d="M70 20 L90 50 120 50" stroke="#323232" stroke-width="2.0" fill="none" marker-mid="url(#circle)" marker-end="url(#arrow)"
					/>
				</g>
				<g id="line-3" @mouseenter="hover($event)" @mouseleave="hover($event)">
					<path id="res1" d="M120 50 L180 50 " stroke="#323232" stroke-width="2.0" fill="none" marker-mid="url(#circle)" marker-end="url(#arrow)"
					/>
				</g>
				<g id="line-4" @mouseenter="hover($event)" @mouseleave="hover($event)">
					<path id="res1" d="M180 50 L200 80 220 80 " stroke="#323232" stroke-width="2.0" fill="none" marker-mid="url(#circle)" marker-end="url(#arrow)"
					/>
				</g>
				<g id="line-5" @mouseenter="hover($event)" @mouseleave="hover($event)">
					<path id="res1" d="M180 110 L200 80 220 80 " stroke="#323232" stroke-width="2.0" fill="none" marker-mid="url(#circle)" marker-end="url(#arrow)"
					/>
				</g>
				<g id="line-6" @mouseenter="hover($event)" @mouseleave="hover($event)">
					<path id="res1" d="M220 80 L280 80  " stroke="#323232" stroke-width="2.0" fill="none" marker-mid="url(#circle)" marker-end="url(#arrow)"
					/>
				</g>
				<g id="line-7" @mouseenter="hover($event)" @mouseleave="hover($event)">
					<path id="res1" d="M280 80 L330 80  " stroke="#323232" stroke-width="2.0" fill="none" marker-mid="url(#circle)" marker-end="url(#arrow)"
					/>
				</g>
				<g id="point-1" @mouseenter="hover($event)" @mouseleave="hover($event)">
					<circle cx="70" cy="20" r="12" stroke="#323232" fill="#fff" />
					<text fill="#000000" font-family="Vijaya" dy=".3em" text-anchor="middle" font-size="13" x="70" y="20">n</text>
				</g>
				<g id="point-2" @mouseenter="hover($event)" @mouseleave="hover($event)">
					<circle cx="20" cy="80" r="12" stroke="#323232" fill="#fff" />
					<text fill="#000000" font-family="Vijaya" dy=".3em" text-anchor="middle" font-size="13" x="20" y="80">w</text>
				</g>

				<g id="point-7" @mouseenter="hover($event)" @mouseleave="hover($event)">
					<circle cx="70" cy="80" r="12" stroke="#323232" fill="#fff" />
					<text fill="#000000" font-family="Vijaya" dy=".3em" text-anchor="middle" font-size="13" x="70" y="80">w2</text>
				</g>

				<g id="point-3" @mouseenter="hover($event)" @mouseleave="hover($event)">
					<circle cx="120" cy="50" r="12" stroke="#323232" fill="#fff" />
					<text fill="#000000" font-family="Vijaya" dy=".3em" text-anchor="middle" font-size="13" x="120" y="50">c1</text>
				</g>
				<g id="point-4" @mouseenter="hover($event)" @mouseleave="hover($event)">
					<circle cx="180" cy="50" r="12" stroke="#323232" fill="#fff" />
					<text fill="#000000" font-weight="bold" font-family="Vijaya" dy=".3em" text-anchor="middle" font-size="13" x="180" y="50">l2</text>
				</g>
				<g id="point-1" @mouseenter="hover($event)" @mouseleave="hover($event)">
					<circle cx="180" cy="110" r="12" stroke="#323232" fill="#fff" />
					<text fill="#000000" font-weight="bold" font-family="Vijaya" dy=".3em" text-anchor="middle" font-size="13" x="180" y="110">n</text>
				</g>
				<g id="point-5" @mouseenter="hover($event)" @mouseleave="hover($event)">
					<circle cx="240" cy="80" r="12" stroke="#323232" fill="#fff" />
					<text fill="#000000" font-weight="bold" font-family="Vijaya" dy=".3em" text-anchor="middle" font-size="13" x="240" y="80">c2</text>
				</g>
				<g id="point-6" @mouseenter="hover($event)" @mouseleave="hover($event)">
					<circle cx="290" cy="80" r="12" stroke="#323232" fill="#fff" />
					<text fill="#000000" font-weight="bold" font-family="Vijaya" dy=".3em" text-anchor="middle" font-size="13" x="290" y="80">o</text>
				</g>
				<g id="point-1" @mouseenter="hover($event)" @mouseleave="hover($event)">
					<circle cx="340" cy="80" r="12" stroke="#323232" fill="#fff" />
					<text fill="#000000" font-weight="bold" font-family="Vijaya" dy=".3em" text-anchor="middle" font-size="13" x="340" y="80">n</text>
				</g>
			</svg>
		</div>
	</div>
</template>

<script>
	var common = require("../common.js");
	export default {
		props: ['obj'],
		data: function () {
			return { templateno: this.obj.templateno, }
		},
		computed: {
			getTemplateNo: function () {

				return this.obj.templateno;
			}
		},
		methods: {
			hover: function (e) {
				var obj = e.target.children;
				var idarr = e.target.id.split("-")
				var type = idarr[0]
				var id = idarr[1]
				var isActive = false;
				var color;
				if (e.type == "mouseenter") {
					//console.log('id:',e.target.id);
					isActive = true;
					color = 'red'
				} else {
					isActive = false
					color = '#323232'
				}
				for (var i = 0; i < obj.length; i++) {
					obj[i].style.stroke = color;
				}
				var _this = this;
				if (type == 'line') {
					//console.log('我是线');
					this.obj.Lines.forEach(function (l, i) {
						if (l.id == id) {
							//console.log('isActive',l.isActive);
							l.isActive = isActive;
							//console.log('isActive',l.isActive);
							//_this.obj.Lines.splice(i, 1, l)
							_this.$emit('changeline', common.deepCopy(l))
						}
					});
				} else if (type = 'point') {
					//console.log('我是点');
					this.obj.Points.forEach(function (p) {
						if (p.id == id) {
							//console.log('isActive',p.isActive);
							p.isActive = isActive;
							//console.log('isActive',p.isActive);
							//_this.obj.Points.splice(i, 1,p)
							_this.$emit('changestatus', common.deepCopy(p))
						}

					});
				}
			}
		}
	}

</script>

<style>

</style>


// WEBPACK FOOTER //
// output-uml.vue?c4aba3fe